import { useNavigate } from "react-router-dom";
import { Container } from "../../components";
import Actas from "../Public/Actas";
import { Card, CardContent, CardHeader } from "@mui/material";
import { Button } from "react-bootstrap";
import { useContext } from "react";
import { UserContext } from "../../context";
import useWindowSize from "../../hooks/useWindowSize";

import EditNoteIcon from "@mui/icons-material/EditNote";
import SourceIcon from "@mui/icons-material/Source";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";

const Home = () => {
  const { actions: ua } = useContext(UserContext);
  const size = useWindowSize();
  const { width } = size;

  const nav = useNavigate();

  const menuOptions = [
    {
      title: "Crear solicitud",
      description: "Inicia el proceso para registrar una nueva solicitud.",
      path: "/crear_solicitud",
      roles: [],
      icon: <EditNoteIcon sx={{ fontSize: 65, color: "#133040" }} />,
    },
    {
      title: "Mis solicitudes",
      description: "Visualiza, administra y realiza el seguimiento de tus solicitudes enviadas.",
      path: "/mis_solicitudes",
      roles: [],
      icon: <FolderOpenIcon sx={{ fontSize: 65, color: "#133040" }} />,
    },
    {
      title: "Inspector",
      description: "Consulta y gestiona las solicitudes existentes para su análisis o revisión.",
      path: "/inspecciones_solicitudes",
      roles: ["admin.app", "inspector.app"],
      icon: <ManageSearchIcon sx={{ fontSize: 65, color: "#133040" }} />,
    },
  ];

  return (
    <>
      <Container
        // tituloApp={"ARBOLADO"}
        size={"md"}
      >
        <section className="d-flex flex-column align-items-center mt-5 ">
          <h2 className="mb-2 pt-3">ARBOLADO</h2>
          <p className="text-center fw-light fs-6 ">
            Bienvenido al sistema de gestión de solicitudes de arbolado urbano.
          </p>
        </section>
        <div
          className={` ${
            width >= 640 ? "" : "flex-column"
          } d-flex flex-wrap   mx-auto justify-content-center w-100   py-2  pb-5 `}
          style={{ maxWidth: "800px" }}
        >
          {menuOptions.map((opc) => {
            if (
              opc.roles.some((role) =>
                ua.getPerfil().roles?.some((userRole) => userRole.name == role)
              ) ||
              opc.roles.length == 0
            ) {
              return (
                <section
                  key={opc.title}
                  className={`${
                    width < 640 ? "col-12 p-3 " : width < 992 ? "col-4 p-0" : "col-4 p-3"
                  } `}
                >
                  <Card
                    key={opc.title}
                    className={`shadow-lg rounded-2xl d-flex flex-column align-items-center p-2 py-3`}
                  >
                    {opc.icon}
                    <h5
                      style={{ color: "#133040", fontSize: "20px" }}
                      className=" font-bold m-0 pt-3 "
                    >
                      {opc.title}
                    </h5>
                    <CardContent className="pt-2">
                      <p
                        className="text-gray-600 text-center "
                        style={{ fontSize: "16px", width: "180px" }}
                      >
                        {opc.description}
                      </p>

                      <Button
                        size="md"
                        style={{ background: "#127AE2", color: "#127AE2" }}
                        className="mt-3 w-100 btn "
                        onClick={() => nav(opc.path)}
                      >
                        Ir a {opc.title}
                      </Button>
                    </CardContent>
                  </Card>
                </section>
              );
            }
          })}
        </div>
      </Container>
      {/* <Actas /> */}
    </>
  );
};
export default Home;
